import jQuery, { parseJSON } from 'jquery';
import axios from 'axios';
import configuration from '../models/configuration';

export default class APIClient {
    constructor(app) {
        //-------------------------------
        //desarrollo
        //-------------------------------
        // this.baseURL = 'https://dev7.kukoa.com/unex/config/api/public/api';
        //-------------------------------

        //-------------------------------
        //pre-produccio
        //-------------------------------
        //this.baseURL = 'https://xr17.unex.net/config/api/public/api';
        //-------------------------------

        //this.baseURL = 'https://xr82.unex.net/config/api/public/api';
        //this.baseURL = 'http://configurador.localhost/api';
        //this.baseURL = 'http://localhost:8000/api';

        this.app = app;

        this.env = 'prod'
    }

    getHeaders() {

        // Headers:
        var headers = {
            'X-localization': this.app.language.id ? this.app.language.id : 'en',
            'X-market': this.app.market.id ? this.app.market.id : 'international',
            'X-webversion': this.app.webVersion ? this.app.webVersion : '1',
        };

        // Afegir accesstoken si estem logats
        // if (this.app.enabled == true && Unex.Authentication.isLogged) {
        if (window.Unex.Authentication.isLogged) {
            // Check for token
            if (window.Unex.Authentication.accessToken) {
                headers["Authorization"] = "Bearer " + window.Unex.Authentication.accessToken;
            } else {
                // window.Unex.Authentication.login(true)
            }
        }

        // Visitor Id Pardot:
        var visitorId = Unex.getCookie('visitor_id876961')
        if( visitorId ){
            headers['x-visitor-id'] = visitorId
        }

        // Wholesaler
        if( this.app.WholeSaler.isWholeSaler == true && this.app.WholeSaler.wholesaler_id != "test" ){
            headers["x-wholesaler-id"] = this.app.WholeSaler.wholesaler_id
            headers["x-wholesaler-domain"] = this.app.WholeSaler.getDomainFromHookUrl()
            headers["x-elbridge-version"] = this.app.WholeSaler.version
        }

        return headers;

    }

    setEnvironment(env, apiUrl) {
        this.env = env

        if (env == 'prod' && !apiUrl) {
            this.baseURL = "https://configurator.unex.net/api/api";
        } else if (!apiUrl) {
            this.baseURL = "https://configurator.unex.net/api/api";
        } else {
            this.baseURL = "https://xr17.unex.net/config/api/public/api";
            this.baseURL = apiUrl;
        }
        // this.baseURL = 'https://xr82.unex.net/config/api/public/api';
    }

    setLanguageMarket(languageId, marketId) {

        //cambia vars perque headers enviats sactualizin bé
        if (languageId) {
            this.app.language.id = languageId;
        }

        if (marketId) {
            this.app.market.id = marketId;
        }

        this.app.loadAvailableMarketsAndLanguages_and_updateCurrentConfig_ifPassed(languageId, marketId);
    }

    get(url, callback, callbackOnError) {
        var self = this;
        self.showSpinner();

        var headers = this.getHeaders();

        jQuery.ajax({
            url: this.baseURL + '/' + url,
            type: 'GET',
            dataType: 'json',
            headers: headers,
            contentType: 'application/json; charset=utf-8',
            xhrFields: {
                withCredentials: true
            },
            success: function (result) {
                self.hideSpinner();
                if (callback) callback(result);
            },
            error: function (error) {
                self.hideSpinner();

                console.log('showModal 2, error: ', error);

                self.showModal(self.app.translate("popup_error_titel"), self.app.translate("popup_conexion_error_message"),);

                if (callbackOnError) callbackOnError(error);
            }
        });
    }
    showSpinner() {
        this.app.showSpinner();
    }
    hideSpinner() {
        this.app.hideSpinner();
    }
    showModal(text, title) {
        this.app.showModal(text, title);
    }
    post(url, data, callback, callbackOnError, showSpinner) {
        var self = this;

        if (showSpinner) { self.showSpinner(); }

        var headers = this.getHeaders();

        jQuery.ajax({
            url: this.baseURL + '/' + url,
            type: 'POST',
            dataType: 'json',
            data: JSON.stringify(data),
            headers: headers,
            xhrFields: {
                withCredentials: true
            },
            contentType: 'application/json; charset=utf-8',
            success: function (result) {
                self.hideSpinner();
                // console.log(result);
                if (callback) callback(result);
            },
            error: function (error) {
                self.hideSpinner();

                //"popup_error_titel": "Error",
                //Here the message could be stored in the app depending on the language
                let infoModal = {
                    modalToShow: "conexionError",
                    title: self.app.translate("popup_error_titel"),
                    message: self.app.translate("popup_conexion_error_message"),
                    html_message: "",
                    showConfirmationButton: true,
                    showCancelButton: false,
                    textConfirmationButton: self.app.translate("accept_text"),
                    textCancelButton: self.app.translate("cancel_text"),
                };

                self.app.showModal(infoModal).then(({ userAction, paramResult }) => {
                    if (userAction === "modal_confirmed") {

                    }
                });

                if (callbackOnError) callbackOnError(error);
            }
        });
    }

    downloadBOM(format, configurationId, callback_OK, callback_KO, callback_connexion_KO) {

        //console.log('ruta: ', this.baseURL + '/configuration/export/' + format);

        //https://dev7.kukoa.com/unex/configurador.api/public/api/test/configurationExport/xlsx
        //https://dev7.kukoa.com/unex/configurador.api/public/api/configuration/export/pdf
        //https://dev7.kukoa.com/unex/configurador.api/public/api/configuration/export/xlsx
        // url: this.baseURL + '/configuration/export/' + format,
        // url: 'https://dev7.kukoa.com/unex/configurador.api/public/api/test/configurationExport/' + format,


        var headers = this.getHeaders();

        try {
            axios({
                url: this.baseURL + '/configuration/export/' + format,
                method: 'POST',
                headers: headers,
                data: this.app.currentConfiguration,
                responseType: 'blob',
                withCredentials: true

            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;

                const fileName = this.app.currentConfiguration.label ?
                    this.app.currentConfiguration.label :
                    'file';
                link.setAttribute('download', fileName + '.' + format); //or any other extension
                document.body.appendChild(link);
                link.click();

                callback_OK();

            }).catch((response) => {

                callback_KO(response);
                console.warn(response);
            });
        } catch (e) {
            callback_connexion_KO(e);
            console.warn(e);
        }
    }

    downloadBlob(format, data, configuratioName) {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;

        const fileName = configuratioName ?
            configuratioName : 'file'
        link.setAttribute('download', fileName + '.' + format); //or any other extension
        document.body.appendChild(link);
        link.click();
    }

    async downloadById(format, configurationId, configurationName) {
        //https://<apiUrl>/api/configuration/{id}/export/{format}

        var headers = this.getHeaders();

        try {
            var extra = ''; // '?XDEBUG_SESSION_START' //'' //
            let response = await axios({
                url: this.baseURL + '/configuration/' + configurationId + '/export/' + format + extra,
                method: 'GET',
                headers: headers,
                responseType: 'blob',
                withCredentials: true
            });

            this.downloadBlob(format, response.data, configurationName);
        } catch (e) {
            console.error(e);
        }
    }

    async downloadByIds(format, configurationIds) {
        // https://<apiUrl>/api/configuration/export-by-ids/{format}
        // POST:
        //  { "ids": [ 1, 2 ] }

        var headers = this.getHeaders();
        var data = {
            ids: configurationIds
        }

        //
        try {
            var extra = '' // '?XDEBUG_SESSION_START' //'' //
            let response = await axios({
                url: this.baseURL + '/configuration/export-by-ids/' + format + extra,
                method: 'POST',
                headers: headers,
                data: data,
                responseType: 'blob',
                withCredentials: true
            });

            this.downloadBlob(format, response.data);
        } catch (e) {
            console.error(e);
        }
    }
    /**
     * Comprova en el servidor si el stage que es passa com a paràmetre és correcte
     *
     * @param {*} stage
     * @param {*} callbackValid
     * @param {*} callbackInvalid
     * @param {*} callbackOnError
     */
    checkStage(stage, callbackValid, callbackInvalid) {
        var self = this;

        this.post(
            'configuration/checkStage/' + stage,
            self.app.currentConfiguration,

            // Connexió amb Server=OK, revisem si el nou stage és vàlid
            function (result) {

                self.app.currentConfiguration = result;

                if (stage == self.app.currentConfiguration.stage) {
                    // Configuracio actual enviada es vàlida per l'stage passat
                    callbackValid();
                } else {
                    // Configuracio actual enviada NO es vàlida per l'stage passat
                    callbackInvalid();
                }

            },

            () => {

            },


            //show spinner
            true
        )
    }

    async asyncProcess(callbackValid, callbackInvalid, callbackOnConnectionError, b_validateCurrentConfig = false, b_showSpinner = false) {

        let self = this;

        try {

            self.app.isProcessing = true;

            let result = await this.postAxios(
                'configuration/process',
                self.app.currentConfiguration,
                b_showSpinner
            );

            //TODO: REVISAR
            if (result) {

                self.app.currentConfiguration = result;
                self.app.saveCurrentConfigurationToSessionStorage();

                // Mirar si el stage tornat pel servidor és igual a l'actual
                let stageIsCorrect = (self.app.currentConfiguration.stage == result.stage) ? true : false;
                let currentconfigIsValid = self.app.currentConfiguration.validation.valid ? true : false;

                //stage i configuracio es valida
                if (stageIsCorrect && currentconfigIsValid) {

                    callbackValid(result);

                    //stage correcte i currentconfig no necesita validacio
                } else if (stageIsCorrect && !b_validateCurrentConfig) {
                    callbackValid(result);

                    //stage no es correcte o currentconfig es incorrecte
                } else {
                    self.validateResult(
                        result,
                        // Resultat Valid
                        function () {
                            callbackValid(result)
                        },
                        // Resultat no valid
                        function (errorMessage) {
                            callbackInvalid(errorMessage);
                        }
                    )
                }
                self.app.isProcessing = false;
                return true;

                //no es retorna result
            } else {
                //console.error('asyncProcess: ', error);
                self.showModal(self.app.translate("popup_error_titel"), self.app.translate("popup_conexion_error_message"),);
                self.app.isProcessing = false;
            }
            return false;
        } catch (error) {
            console.error('catched error asyncProcess: ', error);
            callbackOnConnectionError(error);
            self.app.isProcessing = false;
        }
    }

    validateResult(result, callbackValid, callbackInvalid) {
        Unex.log("Validating results", "Configurator")
        Unex.log(result, "Configurator")
        if (result.validation.valid) {
            // Si no hi ha cap error, cridar callbackOK
            // TODO: Si no hi a errors pero hi ha advertencias, showModal i despres callbackOK
            if (callbackValid) {
                callbackValid();
            }
        } else {
            // Si hi ha errors, cridar callbackKO
            var errorMessage = '';
            result.validation.errors.forEach(element => {
                errorMessage += '<div class="alert alert-danger">' + element.message + '</div>';
            });

            if (callbackInvalid) {
                callbackInvalid(errorMessage);
            }
        }
    }

    //used at test
    getAttributeValues(attribute_id, callback, callbackOnError) {
        this.get(
            'attributes/' + attribute_id, //  + '?XDEBUG_SESSION_START'
            function (result) { callback(result); },
            function (error) { callbackOnError(error); },
        )
    }

    async getAttributeValuesAsync(attribute_id, asList = false) {
        try {
            let result = await this.getAxios(
                'attributes/' + attribute_id
            )

            return result;
        } catch (error) {

        }
    }

    async getMyConfigs() {

        try {
            var result = await this.getAxios('configuration/list');
            return result;

        } catch (e) {
            console.warn(e);
            //throw e;
        }

    }

    async getConfig(configurationId) {
        var result = await this.getAxios('configuration/load/' + configurationId);

        return result;
    }

    async saveConfig(configuration) {

        try {
            await this.postAxios('configuration/save', configuration);
            return true;

        } catch (e) {
            console.warn(e);
            //throw e;
        }

    }

    async deleteConfig(configurationId) {
        var result = await this.getAxios('configuration/delete/' + configurationId);

        //console.log(result);
        return result;
    }
    /**
     * Tries to save configuration
     *
     * @returns {boolean}
     */
    async saveConfiguration() {

        this.app.currentConfiguration.saved = true;

        return await this.asyncProcess(
            () => { },
            () => { },
            () => { },
            false,
            true
        );

    }

    async getProjects() {
        var result = await this.getAxios('projects');

        return result;
    }
    async getProjectsTree() {
        var result = await this.getAxios('projects/tree');

        return result;
    }
    /**
     * Creates a new project
     * @param {String} label
     */
    async createProject(label) {
        var result = await this.postAxios(
            'projects',
            {
                'label': label
            }
        )

        return result
    }
    async getProject(projectId, withConfigurations = false) {
        var result = await this.getAxios(
            'projects/' + projectId +
            (withConfigurations ? "?withConfigurations=true" : "")
        )

        result.isEditing = false

        return result
    }
    async updateProject(project) {
        var result = await this.patchAxios(
            'projects/' + project.id,
            {
                'label': project.label
            }
        )
    }
    async updateProjectById(projectId, newLabel) {
        var result = await this.patchAxios(
            'projects/' + projectId,
            {
                'label': newLabel
            }
        )
    }
    async removeProject(projectId) {
        var result = await this.deleteAxios(
            'projects/' + projectId
        )
    }
    async addMainElement(index) {

        try {
            var result = await this.postAxios(
                'configuration/mainElementParameter/add/' + index,
                this.app.currentConfiguration
            );

            this.app.currentConfiguration = result;

        } catch (error) {
            console.log(error);
        }

    }

    async crossOptions(index, params, ignoreValues = 0) {
        try {
            var result = await this.postAxios(
                'configuration/crossOptions/' + index + "?parameters=" + params + "&ignoreValues=" + ignoreValues,
                this.app.currentConfiguration
            );

            return result;
        } catch (error) {
            console.log(error);
        }
    }

    async getElbridgeJSON() {
        try {
            var result = await this.postAxios(
                'configuration/export/elbridge',
                this.app.currentConfiguration
            );

            console.log('getElbridgeJSON:', result);

            return JSON.stringify(result);
        } catch (error) {
            console.log(error);
            return null;
        }
    }
    /**
     *
     * @param {*} path
     * @param {*} data
     * @param {*} callback_KO
     */
    async postAxios(path, data, showSpinner, retry = true) {

        var self = this;

        if (showSpinner) { self.showSpinner(); }

        var headers = this.getHeaders();

        try {
            // TODO: xdebug
            // posar ? o & en funció del path passat
            var extra = ""; // '?XDEBUG_SESSION_START' //'' //
            var result = await axios({
                url: this.baseURL + '/' + path + extra,
                method: 'POST',
                headers: headers,
                data: data,
                withCredentials: true
            });

            self.hideSpinner();

            return result.data;

        } catch (e) {
            let error = e, status = 200
            console.warn(error.response)
            if (error.response) {
                status = error.response.status
            }

            if (status == 401 && retry) {
                // TODO:
                Unex.Modal.show("Login", "Error de autenticación")
            } else {
                console.warn('postAxios error: ', e);

                self.app.API_error = true;

                //throw e;

                //-----------------
                self.hideSpinner();

                let infoModal = {
                    modalToShow: "conexionError",
                    title: self.app.translate("popup_error_titel"),
                    message: self.app.translate("error_internal_server_error"),
                    html_message: "",
                    showConfirmationButton: true,
                    showCancelButton: false,
                    textConfirmationButton: self.app.translate("accept_text"),
                    textCancelButton: self.app.translate("cancel_text"),
                };

                self.app.showModal(infoModal).then(({ userAction, paramResult }) => {

                    if (userAction === "modal_confirmed" || userAction === "modal_rejected" || userAction === "modal_rejected_backdrop") {

                        self.app.loadCurrentConfigurationFromSessionStorage();

                        //------------------------------
                        //navigate to a inferior stage
                        //------------------------------
                        self.app.navigateToStageAsync(self.app.maxAvailableStage() - 1);
                        //------------------------------
                    }
                });
            }
            //-----------------
        }
    }

    /**
     *
     * @param {*} path
     * @param {*} data
     * @param {*} callback_KO
     */
    async patchAxios(path, data, showSpinner, retry = true) {

        var self = this;

        if (showSpinner) { self.showSpinner(); }

        var headers = this.getHeaders();

        try {
            var extra = '' // '?XDEBUG_SESSION_START' //'' //
            var result = await axios({
                url: this.baseURL + '/' + path + extra,
                method: 'PATCH',
                headers: headers,
                data: data,
                withCredentials: true
            });

            self.hideSpinner();

            return result.data;

        } catch (e) {
            let error = e, status = 200
            console.warn(error.response)
            if (error.response) {
                status = error.response.status
            }

            if (status == 401 && retry) {
                // TODO:
                Unex.Modal.show("Login", "Error de autenticación")
            } else {
                console.warn('postAxios error: ', e);

                self.app.API_error = true;

                //throw e;

                //-----------------
                self.hideSpinner();

                let infoModal = {
                    modalToShow: "conexionError",
                    title: self.app.translate("popup_error_titel"),
                    message: self.app.translate("error_internal_server_error"),
                    html_message: "",
                    showConfirmationButton: true,
                    showCancelButton: false,
                    textConfirmationButton: self.app.translate("accept_text"),
                    textCancelButton: self.app.translate("cancel_text"),
                };

                self.app.showModal(infoModal).then(({ userAction, paramResult }) => {

                    if (userAction === "modal_confirmed" || userAction === "modal_rejected" || userAction === "modal_rejected_backdrop") {

                        self.app.loadCurrentConfigurationFromSessionStorage();

                        //------------------------------
                        //navigate to a inferior stage
                        //------------------------------
                        self.app.navigateToStageAsync(self.app.maxAvailableStage() - 1);
                        //------------------------------
                    }
                });
            }
            //-----------------
        }
    }
    async deleteAxios(path) {

        var self = this;

        var headers = this.getHeaders();

        try {
            var extra = '' // '?XDEBUG_SESSION_START' //'' //
            var result = await axios({
                url: this.baseURL + '/' + path + extra,
                method: 'DELETE',
                headers: headers,
                withCredentials: true
            });

            return result.data;

        } catch (e) {
            let error = e, status = 200
            console.warn(error.response)
            if (error.response) {
                status = error.response.status
            }

            if (status == 401 && retry) {
                // TODO:
                Unex.Modal.show("Login", "Error de autenticación")
            } else {
                console.warn('postAxios error: ', e);

                self.app.API_error = true;

                //throw e;

                //-----------------
                self.hideSpinner();

                let infoModal = {
                    modalToShow: "conexionError",
                    title: self.app.translate("popup_error_titel"),
                    message: self.app.translate("error_internal_server_error"),
                    html_message: "",
                    showConfirmationButton: true,
                    showCancelButton: false,
                    textConfirmationButton: self.app.translate("accept_text"),
                    textCancelButton: self.app.translate("cancel_text"),
                };

                self.app.showModal(infoModal).then(({ userAction, paramResult }) => {

                    if (userAction === "modal_confirmed" || userAction === "modal_rejected" || userAction === "modal_rejected_backdrop") {

                        self.app.loadCurrentConfigurationFromSessionStorage();

                        //------------------------------
                        //navigate to a inferior stage
                        //------------------------------
                        self.app.navigateToStageAsync(self.app.maxAvailableStage() - 1);
                        //------------------------------
                    }
                });
            }
            //-----------------
        }
    }
    /**
     *
     * @param {*} path
     */
    async getAxios(path) {

        var self = this;
        var headers = this.getHeaders();

        try {
            var extra = ''; //'?XDEBUG_SESSION_START' //'' //

            var result = await axios({
                url: this.baseURL + '/' + path + extra,
                method: 'GET',
                headers: headers,
                withCredentials: true
            });

            return result.data;

        } catch (e) {
            let error = e, status = 200
            console.warn(error.response)
            if (error.response) {
                status = error.response.status
            }

            if (status == 401) {
                // TODO:
                Unex.Modal.show("Login", "Error de autenticación")
                return;
            }

            console.warn(e);

            self.app.API_error = true;

            //throw e;

            //-----------------
            self.hideSpinner();

            let infoModal = {
                modalToShow: "conexionError",
                title: self.app.translate("popup_error_titel"),
                message: self.app.translate("error_internal_server_error"),
                html_message: "",
                showConfirmationButton: true,
                showCancelButton: false,
                textConfirmationButton: self.app.translate("accept_text"),
                textCancelButton: self.app.translate("cancel_text"),
            };

            self.app.showModal(infoModal).then(({ userAction, paramResult }) => {

                if (userAction === "modal_confirmed" || userAction === "modal_rejected" || userAction === "modal_rejected_backdrop") {

                    self.app.loadCurrentConfigurationFromSessionStorage();

                    //------------------------------
                    //navigate to a inferior stage
                    //------------------------------
                    self.app.navigateToStageAsync(self.app.maxAvailableStage() - 1);
                    //------------------------------
                }

            });

            //-----------------
        }
    }


}